// Dependencies
import Hero     from 'layouts/hero';
import News     from 'layouts/news';
import Cases    from 'layouts/cases';
import Diplomas from 'layouts/diplomas';


class PageHome {
  /**
   * Constructor: Home Page Constructor.
   */
  constructor() {
    // Root
    this._root = document.querySelector('[layout="page-home"]');

    // Dependencies
    this.Hero     = new Hero();
    this.News     = new News();
    this.Cases    = new Cases();
    this.Diplomas = new Diplomas();
  }


  /**
   * Resize: Resize the page.
   */
  resize() {
    this.Cases.resize();
    this.Diplomas.resize();
  }
}

export default PageHome;


// WEBPACK FOOTER //
// ./src/js/templates/page-home.js